import Loadable from 'react-loadable';

import AccountResolver from './src/AccountResolver/AccountResolver';
import AddressForm from './src/AddressForm/AddressForm';
import ChestInventory from './src/ChestInventory';
import { ChestInventoryBody } from './src/ChestInventory/ChestInventory';
import PlayMoney from './src/Header/PlayMoney/PlayMoney';
import ForcedOccupation from './src/Occupation/ForcedOccupation/ForcedOccupation';
import Occupation from './src/Occupation/Occupation';
import { PEPHIOOptions } from './src/Occupation/PEPHIOSelection/PEPHIOSelection';
import CasinoSessionReminderForm from './src/ResponsibleGaming/CasinoSessionReminder/CasinoSessionReminderForm/CasinoSessionReminderForm';
import ExclusionResponse from './src/ResponsibleGaming/TakeABreakFromUs/ExclusionResponse/ExclusionResponse';
import ExclusionTitle, {
  getExclusionTitle
} from './src/ResponsibleGaming/TakeABreakFromUs/ExclusionTitle/ExclusionTitle';
import TakeABreakFromUsInformation from './src/ResponsibleGaming/TakeABreakFromUs/TakeABreakFromUsInformation/TakeABreakFromUsInformation';
import useExclusionType from './src/ResponsibleGaming/TakeABreakFromUs/hooks/useExclusionType';
import Error from './src/ResponsibleGaming/shared/Error/Error';
import useSelfExclusionData from './src/ResponsibleGaming/shared/hooks/useSelfExclusionData';
import StarsQuiz from './src/StarsQuiz/StarsQuiz';
import timezoneMap from './src/TimeZone/timezone-map.json';
import TournamentMoney, { TournamentMoneyBody } from './src/TournamentMoney/TournamentMoney';
import TournamentTickets, {
  TournamentTicketsBody
} from './src/TournamentTickets/TournamentTickets';
import useIsDesktop from './src/hooks/useIsDesktop';
import useMitId from './src/hooks/useMitId';
import styles from './src/styles/styles.scss';

export {
  AccountResolver,
  AddressForm,
  CasinoSessionReminderForm,
  ChestInventory,
  ChestInventoryBody,
  Error,
  ExclusionResponse,
  ExclusionTitle,
  ForcedOccupation,
  Occupation,
  PEPHIOOptions,
  PlayMoney,
  StarsQuiz,
  TournamentMoney,
  TournamentMoneyBody,
  TournamentTickets,
  TournamentTicketsBody,
  styles,
  TakeABreakFromUsInformation,
  timezoneMap,
  getExclusionTitle,
  useIsDesktop,
  useMitId,
  useSelfExclusionData,
  useExclusionType
};

const StarsAccount = Loadable({
  loader: () => import(/* webpackChunkName: "StarsAccount" */ './src/Account/Account'),
  modules: ['./StarsAccount'],
  loading: () => null
});

export default StarsAccount;
